import React, { useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Container,
  Label,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { checkLogin, apiError } from "../../store/actions";
import logodark from "../../assets/images/logo.png";
import withRouter from "../../components/Common/withRouter";
import toastr from "toastr";

function Login(props) {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  const hasMounted = React.useRef(false);
  useEffect(() => {
    if (hasMounted.current) {
      if (props.loginError) {
        const message =
          typeof props.loginError?.response?.data?.message === "string"
            ? props.loginError.response.data.message
            : props.loginError.response.data.message?.[0] || "Login failed";
        toastr.error(message, "Login Failed");
      }
    } else {
      hasMounted.current = true;
    }
  }, [props.loginError]);

  const onSubmit = (values) => {
    props.checkLogin(values, props.router.navigate);
  };

  useEffect(() => {
    props.apiError("");
    document.body.classList.add("auth-body-bg");

    return () => {
      document.body.classList.remove("auth-body-bg");
    };
  }, [props]);

  return (
    <React.Fragment>
      <div>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col lg={4}>
              <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={9}>
                      <div>
                        <div className="text-center">
                          <Link to="/" className="">
                            <img
                              src={logodark}
                              alt=""
                              height="20"
                              className="auth-logo logo-dark mx-auto"
                            />
                          </Link>
                          <h4 className="font-size-18 mt-4">Welcome Back!</h4>
                          <p className="text-muted">
                            Sign in to continue to ValFuels.
                          </p>
                        </div>
                        <div className="p-2 mt-5">
                          <form
                            className="form-horizontal"
                            onSubmit={handleSubmit(onSubmit)}
                          >
                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-user-2-line auti-custom-input-icon"></i>
                              <Label htmlFor="email">Email</Label>
                              <Controller
                                name="email"
                                control={control}
                                rules={{
                                  required: "userid is required",
                                }}
                                render={({ field }) => (
                                  <Input
                                    {...field}
                                    type="text"
                                    className={`form-control ${errors.email ? "is-invalid" : ""
                                      }`}
                                    placeholder="Enter userid"
                                  />
                                )}
                              />
                              {errors.email && (
                                <div className="invalid-feedback">
                                  {errors.email.message}
                                </div>
                              )}
                            </div>

                            <div className="auth-form-group-custom mb-4">
                              <i className="ri-lock-2-line auti-custom-input-icon"></i>
                              <Label htmlFor="password">Password</Label>
                              <Controller
                                name="password"
                                control={control}
                                rules={{
                                  required: "Password is required",
                                }}
                                render={({ field }) => (
                                  <Input
                                    {...field}
                                    type="password"
                                    autoComplete="new-password"
                                    className={`form-control ${errors.password ? "is-invalid" : ""
                                      }`}
                                    id="password"
                                    placeholder="Enter password"
                                  />
                                )}
                              />
                              {errors.password && (
                                <div className="invalid-feedback">
                                  {errors.password.message}
                                </div>
                              )}
                            </div>

                            <div className="form-check">
                              <Input
                                type="checkbox"
                                className="form-check-input"
                                id="customControlInline"
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="customControlInline"
                              >
                                Remember me
                              </Label>
                            </div>

                            <div className="mt-4 text-center">
                              <Button
                                color="primary"
                                className="w-md waves-effect waves-light"
                                type="submit"
                              >
                                Log In
                              </Button>
                            </div>

                            {/* <div className="mt-4 text-center">
                              <Link
                                to="/forgot-password"
                                className="text-muted"
                              >
                                <i className="mdi mdi-lock me-1"></i> Forgot
                                your password?
                              </Link>
                            </div> */}
                          </form>
                        </div>

                        <div className="mt-5 text-center">
                          {/* <p>
                            Don't have an account?{" "}
                            <Link
                              to="/register"
                              className="fw-medium text-primary"
                            >
                              {" "}
                              Register{" "}
                            </Link>
                          </p> */}
                          <p>
                            © 2021 ValFuels. Crafted with{" "}
                            <i className="mdi mdi-heart text-danger"></i> by{" "}
                            <Link to="https://www.ValFuels.com" target="_blank" rel="noreferrer">
                              ValFuels India
                            </Link>
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            <Col lg={8}>
              <div className="authentication-bg">
                <div className="bg-overlay"></div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const { loginError } = state.Login;
  return { loginError };
};

export default withRouter(
  connect(mapStateToProps, { checkLogin, apiError })(Login)
);
